<template>
  <v-form @submit.prevent="save">
    <div class="mb-4">
      <span class="text-body-1">
        <span class="font-weight-bold secondary-font">{{
          $t("users.infos.title")
        }}</span>
      </span>
    </div>
    <div>
      <v-text-field
        v-model="form.profile.first_name"
        :label="$t('security.fields.first_name.title')"
        append-icon="mdi-card-account-details-outline"
        dense
        @input="delayTouch($v.form.profile.first_name)"
        @blur="$v.form.profile.first_name.$touch()"
        :error-messages="errorsFirstName"
        class="mb-3"
        maxlength="100"
      ></v-text-field>
      <v-text-field
        v-model="form.profile.last_name"
        :label="$t('security.fields.last_name.title')"
        append-icon="mdi-card-account-details-outline"
        dense
        @input="delayTouch($v.form.profile.last_name)"
        @blur="$v.form.profile.last_name.$touch()"
        :error-messages="errorsLastName"
        class="mb-3"
        maxlength="100"
      ></v-text-field>
      <v-text-field
        v-model="form.profile.email"
        :label="$t('security.fields.email.title')"
        append-icon="mdi-at"
        dense
        @input="delayTouch($v.form.profile.email)"
        @blur="$v.form.profile.email.$touch()"
        :error-messages="errorsEmail"
        class="mb-3"
        maxlength="150"
      ></v-text-field>
      <v-text-field
        v-model="form.profile.phone"
        :label="$t('security.fields.phone.title')"
        :hint="$t('security.fields.phone.help')"
        persistent-hint
        append-icon="mdi-phone-outline"
        dense
        @input="delayTouch($v.form.profile.phone)"
        @blur="$v.form.profile.phone.$touch()"
        :error-messages="errorsPhone"
        class="mb-5"
        maxlength="12"
      ></v-text-field>
    </div>
    <div class="my-4">
      <span class="text-body-1">
        <span class="font-weight-bold secondary-font">{{
          $t("users.security.title")
        }}</span>
      </span>
    </div>
    <div>
      <v-text-field
        v-model="form.username"
        :label="$t('security.fields.username.title')"
        append-icon="mdi-account-outline"
        dense
        class="mb-3"
        @input="delayTouch($v.form.username)"
        @blur="$v.form.username.$touch()"
        :error-messages="errorsUsername"
        maxlength="50"
        :disabled="this.user.id ? true : false"
      ></v-text-field>
      <v-select
        v-model="form.role"
        :label="$t('users.fields.role.title')"
        append-icon="mdi-shield-account-outline"
        dense
        :items="items.roles"
        :item-text="(item) => $t(item.text)"
        class="mb-3"
        @input="delayTouch($v.form.role)"
        @blur="$v.form.role.$touch()"
        :error-messages="errorsRole"
      >
      </v-select>
      <v-text-field
        v-model="form.password"
        :label="$t('security.fields.password.title')"
        append-icon="mdi-shield-key-outline"
        dense
        class="mb-3"
        @input="delayTouch($v.form.password)"
        @blur="$v.form.password.$touch()"
        :error-messages="errorsPassword"
        type="password"
        autocomplete="off"
        maxlength="50"
      ></v-text-field>
      <v-text-field
        v-model="form.confirm_password"
        :label="$t('security.fields.confirm_password.title2')"
        append-icon="mdi-shield-key-outline"
        dense
        class="mb-3"
        @input="delayTouch($v.form.confirm_password)"
        @blur="$v.form.confirm_password.$touch()"
        :error-messages="errorsConfirmPassword"
        type="password"
        autocomplete="off"
        maxlength="50"
      ></v-text-field>
      <v-checkbox
        :label="$t('users.fields.active.title')"
        v-model="form.active"
        color="primary"
        dense
        class="mb-3"
      ></v-checkbox>
    </div>
    <div class="my-4">
      <span class="text-body-1">
        <span class="font-weight-bold secondary-font">{{
          $t("users.cga.title")
        }}</span>
      </span>
    </div>
    <div>
      <v-autocomplete
        :items="items.cga"
        :label="$t('users.fields.cga_readonly.title')"
        dense
        class="mb-3 mt-7"
        color="primary"
        v-model="form.cga_readonly_id"
        @input="delayTouch($v.form.cga_readonly_id)"
        @blur="$v.form.cga_readonly_id.$touch()"
        :error-messages="errorsCgaReadonlyId"
        item-value="id"
        item-text="identifier"
      ></v-autocomplete>
      <v-autocomplete
        :items="items.cga"
        :label="$t('users.fields.cga.title')"
        dense
        class="mb-3"
        color="primary"
        v-model="form.cga_id"
        @input="delayTouch($v.form.cga_id)"
        @blur="$v.form.cga_id.$touch()"
        :error-messages="errorsCgaId"
        item-value="id"
        item-text="identifier"
      ></v-autocomplete>
    </div>
    <div class="my-4">
      <span class="text-body-1">
        <span class="font-weight-bold secondary-font">{{
          $t("users.mynetwork.title")
        }}</span>
      </span>
    </div>
    <div>
      <v-text-field
        v-model="form.mynetwork.username"
        :label="$t('users.fields.mynetwork_username.title')"
        append-icon="mdi-file-key-outline"
        dense
        @input="delayTouch($v.form.mynetwork.username)"
        @blur="$v.form.mynetwork.username.$touch()"
        :error-messages="errorsMyNetworkUsername"
        class="mb-3"
        maxlength="50"
      ></v-text-field>
      <v-text-field
        v-model="form.mynetwork.password"
        :label="$t('users.fields.mynetwork_password.title')"
        append-icon="mdi-file-key-outline"
        dense
        @input="delayTouch($v.form.mynetwork.password)"
        @blur="$v.form.mynetwork.password.$touch()"
        :error-messages="errorsMyNetworkPassword"
        class="mb-3"
        maxlength="50"
      ></v-text-field>
    </div>
    <div class="d-flex justify-end mt-4">
      <v-btn
        type="submit"
        color="primary"
        :disabled="$v.form.$invalid"
        :loading="loading.save"
        >{{ $t(this.user.id ? "btn.update" : "btn.save") }}</v-btn
      >
    </div>
  </v-form>
</template>

<script>
import {
  required,
  maxLength,
  minLength,
  email,
  helpers,
  sameAs,
} from "vuelidate/lib/validators";
import FormDelayMixin from "./../../mixins/commons/form-delay-touch";
import FormMixin from "./../../mixins/commons/form";
import Vue from "vue";

const defaultForm = {
  username: null,
  password: null,
  confirm_password: null,
  role: "ROLE_PARTNER",
  active: true,
  cga_id: null,
  cga_readonly_id: null,
  profile: {
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
  },
  mynetwork: {
    username: null,
    password: null,
  },
};

export default {
  mixins: [FormDelayMixin, FormMixin],
  props: {
    user: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  async created() {
    this.initForm();
    await this.initCgaItems();
  },
  data: () => ({
    form: Vue._.cloneDeep(defaultForm),
    items: {
      roles: [
        { text: "users.fields.role.ROLE_PARTNER", value: "ROLE_PARTNER" },
        { text: "users.fields.role.ROLE_ADMIN", value: "ROLE_ADMIN" },
      ],
      cga: [],
    },
    loading: {
      save: false,
    },
  }),
  validations() {
    const validations = {
      form: {
        profile: {
          first_name: {
            required,
            maxLength: maxLength(100),
          },
          last_name: {
            required,
            maxLength: maxLength(100),
          },
          email: {
            required,
            email,
          },
          phone: {
            required,
            regex: helpers.regex(
              "phone",
              /^(237)((6(?:[5-9][0-9]{7}))|((242|243|620)[0-9]{6}))$/
            ),
          },
        },
        username: {
          required,
          maxLength: maxLength(30),
          minLength: minLength(5),
        },
        role: {
          required,
          regex: helpers.regex("role", /^ROLE_PARTNER|ROLE_ADMIN$/),
        },
        password: {
          minLength: minLength(5),
          maxLength: maxLength(50),
        },
        confirm_password: {
          sameAsPassword: sameAs("password"),
        },
        mynetwork: {
          username: {
            required,
            maxLength: maxLength(50),
          },
          password: {
            required,
            maxLength: maxLength(50),
          },
        },
        cga_id: {
          required,
        },
        cga_readonly_id: {
          required,
        },
      },
    };

    if (!this.user.id) {
      validations.form.password.required = required;
    }

    if (!this.user.id) {
      validations.form.username.matchUsername = (value) => {
        if (!helpers.req(value)) return true;

        return /^[0-9a-z_-]+$/i.test(value);
      };
    }

    return validations;
  },
  methods: {
    initForm() {
      if (!this.user.id) return;
      this.form = {
        username: this.user.username,
        password: null,
        confirm_password: null,
        role: this.user.role,
        active: this.user.active,
        profile: {
          first_name: this.user.profile.first_name,
          last_name: this.user.profile.last_name,
          email: this.user.profile.email,
          phone: this.user.profile.phone,
        },
        mynetwork: {
          username: this.user?.mynetwork?.username,
          password: this.user?.mynetwork?.password,
        },
        cga_id: this.user.cga_id,
        cga_readonly_id: this.user.cga_readonly_id,
      };
    },
    getPath() {
      return this.user.id ? `/api/users/${this.user.id}` : "/api/users";
    },
    getMessages() {
      return {
        200: this.$t("users.edit.success"),
        201: this.$t("users.add.success"),
        403: true,
        400: true,
        422: (error) => {
          if (error.code === "E101") {
            return this.$t("security.fields.username.exists");
          }
        },
        500: true,
      };
    },
    preSubmit() {
      this.loading.save = true;
    },
    postSubmit() {
      this.loading.save = false;
      if (!this.user.id) {
        this.resetForm();
      }
    },
    getData(form) {
      // eslint-disable-next-line no-unused-vars
      const { confirm_password, ...data } = form;
      return data;
    },
    getMethod() {
      return this.user.id ? "PUT" : "POST";
    },
    resetForm() {
      this.form = this._.cloneDeep(defaultForm);
      this.$v.form.$reset();
    },
    async initCgaItems() {
      try {
        const response = await this.request({ url: "/api/cga-manager/items" });
        this.items.cga = response.data;
      } catch (error) {
        // empty
      }
    },
  },
  computed: {
    errorsFirstName() {
      const errors = [];

      if (!this.$v.form.profile.first_name.$dirty) return errors;

      !this.$v.form.profile.first_name.required &&
        errors.push(this.$t("security.fields.first_name.required"));
      !this.$v.form.profile.first_name.maxLength &&
        errors.push(
          this.$t("security.fields.first_name.max_length", {
            max: this.$v.form.profile.first_name.$params.maxLength.max,
          })
        );

      return errors;
    },
    errorsLastName() {
      const errors = [];

      if (!this.$v.form.profile.last_name.$dirty) return errors;

      !this.$v.form.profile.last_name.required &&
        errors.push(this.$t("security.fields.last_name.required"));
      !this.$v.form.profile.last_name.maxLength &&
        errors.push(
          this.$t("security.fields.last_name.max_length", {
            max: this.$v.form.profile.last_name.$params.maxLength.max,
          })
        );

      return errors;
    },
    errorsEmail() {
      const errors = [];

      if (!this.$v.form.profile.email.$dirty) return errors;

      !this.$v.form.profile.email.required &&
        errors.push(this.$t("security.fields.email.required"));
      !this.$v.form.profile.email.email &&
        errors.push(this.$t("security.fields.email.invalid"));

      return errors;
    },
    errorsPhone() {
      const errors = [];

      if (!this.$v.form.profile.phone.$dirty) return errors;

      !this.$v.form.profile.phone.required &&
        errors.push(this.$t("security.fields.phone.required"));
      !this.$v.form.profile.phone.regex &&
        errors.push(this.$t("security.fields.phone.invalid"));

      return errors;
    },
    errorsUsername() {
      const errors = [];

      if (!this.$v.form.username.$dirty) return errors;

      !this.$v.form.username.required &&
        errors.push(this.$t("security.fields.username.required"));
      !this.$v.form.username.maxLength &&
        errors.push(
          this.$t("security.fields.username.max_length", {
            max: this.$v.form.username.$params.maxLength.max,
          })
        );
      !this.$v.form.username.minLength &&
        errors.push(
          this.$t("security.fields.username.min_length", {
            max: this.$v.form.username.$params.minLength.min,
          })
        );

      this.$objectPath.has(this.$v.form.username, "matchUsername") &&
        !this.$v.form.username.matchUsername &&
        errors.push(this.$t("security.fields.username.invalid"));

      return errors;
    },
    errorsRole() {
      const errors = [];

      if (!this.$v.form.role.$dirty) return errors;

      !this.$v.form.role.required &&
        errors.push(this.$t("users.fields.role.required"));
      !this.$v.form.role.regex &&
        errors.push(this.$t("users.fields.role.invalid"));

      return errors;
    },
    errorsPassword() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;

      this.$objectPath.has(this.$v.form.password, "required") &&
        !this.$v.form.password.required &&
        errors.push(this.$t("security.fields.new_password.required"));

      !this.$v.form.password.minLength &&
        errors.push(
          this.$t("security.fields.password.min_length", {
            min: this.$v.form.password.$params.minLength.min,
          })
        );

      !this.$v.form.password.maxLength &&
        errors.push(
          this.$t("security.fields.password.max_length", {
            min: this.$v.form.password.$params.maxLength.max,
          })
        );
      return errors;
    },
    errorsConfirmPassword() {
      const errors = [];
      if (!this.$v.form.confirm_password.$dirty) return errors;

      !this.$v.form.confirm_password.sameAsPassword &&
        errors.push(this.$t("security.fields.confirm_password.same_as"));
      return errors;
    },
    errorsMyNetworkUsername() {
      const errors = [];

      if (!this.$v.form.mynetwork.username.$dirty) return errors;

      !this.$v.form.mynetwork.username.required &&
        errors.push(this.$t("users.fields.mynetwork_username.required"));
      !this.$v.form.mynetwork.username.maxLength &&
        errors.push(
          this.$t("users.fields.mynetwork_username.max_length", {
            max: this.$v.form.mynetwork.username.$params.maxLength.max,
          })
        );

      return errors;
    },
    errorsMyNetworkPassword() {
      const errors = [];

      if (!this.$v.form.mynetwork.password.$dirty) return errors;

      !this.$v.form.mynetwork.password.required &&
        errors.push(this.$t("users.fields.mynetwork_password.required"));
      !this.$v.form.mynetwork.password.maxLength &&
        errors.push(
          this.$t("users.fields.mynetwork_password.max_length", {
            max: this.$v.form.mynetwork.password.$params.maxLength.max,
          })
        );

      return errors;
    },
    errorsCgaReadonlyId() {
      const errors = [];

      if (!this.$v.form.cga_readonly_id.$dirty) return errors;

      !this.$v.form.cga_readonly_id.required &&
        errors.push(this.$t("users.fields.cga_readonly.required"));

      return errors;
    },
    errorsCgaId() {
      const errors = [];

      if (!this.$v.form.cga_id.$dirty) return errors;

      !this.$v.form.cga_id.required &&
        errors.push(this.$t("users.fields.cga.required"));

      return errors;
    },
  },
};
</script>
